(function () {
    'use strict';

    if (window.MetodoBluPhRegulatorCalculatorInitialized) return;
    window.MetodoBluPhRegulatorCalculatorInitialized = true;

    var STORAGE_KEY_PREFIX = 'ph-regulator-calculator';

    function getNumber(value) {
        var normalized = String(value).trim().replace(',', '.');
        var parsed = parseFloat(normalized);
        return isNaN(parsed) ? null : parsed;
    }

    function formatNumber(value, decimals) {
        if (value === null || typeof value === 'undefined' || isNaN(value)) return '—';
        var fixed = value.toFixed(decimals);
        return fixed.replace(/\.0+$/, '').replace(/(\.\d*?)0+$/, '$1');
    }

    function formatMessage(template, replacements) {
        return String(template || '').replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, function (_, token) {
            return Object.prototype.hasOwnProperty.call(replacements, token) ? replacements[token] : '';
        });
    }

    function escapeHtml(value) {
        return String(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function decodeHtmlEntities(value) {
        if (!value) return value;
        var parser = document.createElement('textarea');
        parser.innerHTML = value;
        return parser.value;
    }

    function convertVolumeForDose(volumeM3, volumeUnit) {
        var normalizedUnit = String(volumeUnit || 'm3').toLowerCase();

        if (normalizedUnit === 'l' || normalizedUnit === 'lt' || normalizedUnit === 'liter' || normalizedUnit === 'liters' || normalizedUnit === 'litre' || normalizedUnit === 'litres') {
            return volumeM3 * 1000;
        }

        return volumeM3;
    }

    function calcVolume(state) {
        var depth = state.depth;
        if (!depth || depth <= 0) return 0;

        if (state.shape === 'rectangular') {
            if (!state.length || !state.width || state.length <= 0 || state.width <= 0) return 0;
            return state.length * state.width * depth;
        }

        if (state.shape === 'oval') {
            if (!state.length || !state.width || state.length <= 0 || state.width <= 0) return 0;
            return (Math.PI / 4) * state.length * state.width * depth;
        }

        if (state.shape === 'circular') {
            if (!state.diameter || state.diameter <= 0) return 0;
            return (Math.PI / 4) * state.diameter * state.diameter * depth;
        }

        if (state.shape === 'custom') {
            if (!state.surface || state.surface <= 0) return 0;
            return state.surface * depth;
        }

        return 0;
    }

    document.querySelectorAll('[data-prc-root]').forEach(function (root, rootIndex) {
        var shapeInputs = root.querySelectorAll('[data-prc-shape]');
        var inputEls = root.querySelectorAll('[data-prc-input]');
        var volumePreview = root.querySelector('[data-prc-volume-preview]');
        var volumeDisplay = root.querySelector('[data-prc-volume-display]');
        var result = root.querySelector('[data-prc-result]');
        var resultMessage = root.querySelector('[data-prc-result-message]');
        var resultVolume = root.querySelector('[data-prc-result-volume]');
        var resultCurrentPh = root.querySelector('[data-prc-result-current-ph]');
        var resultDesiredPh = root.querySelector('[data-prc-result-desired-ph]');
        var resultDose = root.querySelector('[data-prc-result-dose]');
        var currentPhInput = root.querySelector('[data-prc-input="current_ph"]');
        var referenceLine = root.querySelector('[data-prc-reference-line]');
        var referenceLabel = root.querySelector('[data-prc-reference-label]');
        var storageKey = STORAGE_KEY_PREFIX + ':' + window.location.pathname + ':' + rootIndex;

        var config = {
            ready: root.getAttribute('data-prc-config-ready') === 'true',
            doseAmount: getNumber(root.getAttribute('data-prc-dose-amount')) || 0,
            doseUnit: root.getAttribute('data-prc-dose-unit') || 'kg',
            phChange: getNumber(root.getAttribute('data-prc-ph-change')) || 0,
            perVolume: getNumber(root.getAttribute('data-prc-per-volume')) || 0,
            volumeUnit: root.getAttribute('data-prc-volume-unit') || 'm3',
            recommendedPh: getNumber(root.getAttribute('data-prc-recommended-ph')) || 7.2,
            raiseTemplate: decodeHtmlEntities(root.getAttribute('data-prc-i18n-raise-to-target')) || 'Per portare il pH a {{ target }}, aggiungi {{ amount }} {{ unit }}.',
            lowerTemplate: decodeHtmlEntities(root.getAttribute('data-prc-i18n-lower-to-target')) || 'Per portare il pH a {{ target }}, aggiungi {{ amount }} {{ unit }}.',
            alreadyInRange: decodeHtmlEntities(root.getAttribute('data-prc-i18n-already-in-range')) || 'L’acqua è già nel range ideale. Non è necessario aggiungere prodotto.',
            useIncreaser: decodeHtmlEntities(root.getAttribute('data-prc-i18n-use-increaser')) || 'Il pH è sotto il valore ideale. Usa un prodotto per aumentare il pH.',
            useDecreaser: decodeHtmlEntities(root.getAttribute('data-prc-i18n-use-decreaser')) || 'Il pH è sopra il valore ideale. Usa un prodotto per abbassare il pH.',
            missingConfiguration: decodeHtmlEntities(root.getAttribute('data-prc-i18n-missing-configuration')) || 'Manca la configurazione del dosaggio per questo prodotto.'
        };

        var state = {
            shape: 'rectangular',
            length: null,
            width: null,
            diameter: null,
            surface: null,
            depth: 1.2,
            current_ph: 7.2,
            desired_ph: 7.2,
            volume: 0
        };

        function persistState() {
            try {
                var payload = {
                    shape: state.shape,
                    length: state.length,
                    width: state.width,
                    diameter: state.diameter,
                    surface: state.surface,
                    depth: state.depth,
                    current_ph: state.current_ph,
                    desired_ph: state.desired_ph
                };
                localStorage.setItem(storageKey, JSON.stringify(payload));
            } catch (error) {
                // Ignore unavailable storage.
            }
        }

        function restoreState() {
            try {
                var raw = localStorage.getItem(storageKey);
                if (!raw) return;

                var parsed = JSON.parse(raw);
                if (!parsed || typeof parsed !== 'object') return;

                if (parsed.shape && ['rectangular', 'oval', 'circular', 'custom'].indexOf(parsed.shape) !== -1) {
                    state.shape = parsed.shape;
                    shapeInputs.forEach(function (input) {
                        input.checked = input.value === parsed.shape;
                    });
                }

                inputEls.forEach(function (input) {
                    var key = input.getAttribute('data-prc-input');
                    if (!Object.prototype.hasOwnProperty.call(parsed, key)) return;
                    var value = parsed[key];
                    if (value === null || typeof value === 'undefined' || value === '') return;
                    input.value = value;
                    state[key] = getNumber(value);
                });
            } catch (error) {
                // Ignore invalid persisted payload.
            }
        }

        function updateLiveValue(key) {
            var valueEl = root.querySelector('[data-prc-live-value="' + key + '"]');
            if (!valueEl) return;
            var value = state[key];
            valueEl.textContent = value === null ? '—' : formatNumber(value, 1);
        }

        function setResultState(stateName) {
            result.classList.remove('is-error', 'is-warning', 'is-success');
            if (stateName) result.classList.add(stateName);
        }

        function updateShapeFields() {
            root.querySelectorAll('[data-prc-shape-fields]').forEach(function (group) {
                var shapes = (group.getAttribute('data-prc-shape-fields') || '').split(' ');
                var visible = shapes.indexOf(state.shape) !== -1;
                group.classList.toggle('is-hidden', !visible);
            });
        }

        function syncVolumePreview() {
            state.volume = calcVolume(state);

            if (volumePreview) volumePreview.hidden = state.volume <= 0;
            if (volumeDisplay) {
                volumeDisplay.textContent = state.volume > 0
                    ? formatNumber(state.volume, 1) + ' m³ (' + Math.round(state.volume * 1000) + ' L)'
                    : '—';
            }
        }

        function updateReferenceMarker() {
            if (!currentPhInput || !referenceLine) return;

            var min = getNumber(currentPhInput.min);
            var max = getNumber(currentPhInput.max);
            var referenceValue = 7.2;

            if (min === null || max === null || max <= min) return;

            var percent = ((referenceValue - min) / (max - min)) * 100;

            referenceLine.style.left = 'calc(' + percent + '%)';
            if (referenceLabel) {
                referenceLabel.style.left = 'calc(' + percent + '%)';
                referenceLabel.textContent = formatNumber(referenceValue, 1);
            }
        }

        function getRecommendation() {
            if (!config.ready || !config.doseAmount || !config.perVolume || !config.phChange) {
                return {
                    status: 'is-error',
                    message: config.missingConfiguration,
                    dose: null
                };
            }

            if (!state.volume || state.current_ph === null || state.desired_ph === null) return null;
            if (state.current_ph < 0 || state.current_ph > 14) return null;
            if (state.desired_ph < 0 || state.desired_ph > 14) return null;

            if (Math.abs(state.desired_ph - state.current_ph) <= 0.000001) {
                return {
                    status: 'is-success',
                    message: config.alreadyInRange,
                    dose: 0
                };
            }

            if (config.phChange > 0 && state.desired_ph < state.current_ph) {
                return {
                    status: 'is-warning',
                    message: config.useDecreaser,
                    dose: null
                };
            }

            if (config.phChange < 0 && state.desired_ph > state.current_ph) {
                return {
                    status: 'is-warning',
                    message: config.useIncreaser,
                    dose: null
                };
            }

            var delta = Math.abs(state.desired_ph - state.current_ph);
            if (delta <= 0) {
                return {
                    status: 'is-success',
                    message: config.alreadyInRange,
                    dose: 0
                };
            }

            var volumeForDose = convertVolumeForDose(state.volume, config.volumeUnit);
            var steps = delta / Math.abs(config.phChange);
            var dose = steps * config.doseAmount * (volumeForDose / config.perVolume);
            var doseText = formatNumber(dose, 2);
            var targetText = formatNumber(state.desired_ph, 1);
            var template = state.desired_ph > state.current_ph ? config.raiseTemplate : config.lowerTemplate;

            return {
                status: 'is-success',
                message: formatMessage(template, {
                    amount: '<span class="prc-result__amount">' + escapeHtml(doseText) + '</span>',
                    target: '<strong class="prc-result__target">' + escapeHtml(targetText) + '</strong>',
                    unit: '<span class="prc-result__unit">' + escapeHtml(config.doseUnit) + '</span>'
                }),
                isHtml: true,
                dose: dose
            };
        }

        function renderResult() {
            var hasEnoughInput = state.volume > 0 &&
                state.current_ph !== null &&
                state.current_ph >= 0 &&
                state.current_ph <= 14 &&
                state.desired_ph !== null &&
                state.desired_ph >= 0 &&
                state.desired_ph <= 14;

            if (!hasEnoughInput) {
                if (result) result.hidden = true;
                return;
            }

            var recommendation = getRecommendation();
            if (!recommendation) {
                if (result) result.hidden = true;
                return;
            }

            result.hidden = false;
            setResultState(recommendation.status);
            if (recommendation.isHtml) {
                resultMessage.innerHTML = recommendation.message;
            } else {
                resultMessage.textContent = recommendation.message;
            }
            if (resultVolume) {
                resultVolume.textContent = formatNumber(state.volume, 1) + ' m³';
            }
            if (resultCurrentPh) {
                resultCurrentPh.textContent = formatNumber(state.current_ph, 1);
            }
            if (resultDesiredPh) {
                resultDesiredPh.textContent = formatNumber(state.desired_ph, 1);
            }
            if (resultDose) {
                resultDose.textContent = recommendation.dose === null
                    ? '—'
                    : formatNumber(recommendation.dose, 2) + ' ' + config.doseUnit;
            }
        }

        shapeInputs.forEach(function (input) {
            input.addEventListener('change', function () {
                state.shape = input.value;
                updateShapeFields();
                syncVolumePreview();
                renderResult();
                persistState();
            });
        });

        inputEls.forEach(function (input) {
            var key = input.getAttribute('data-prc-input');
            state[key] = getNumber(input.value);
            updateLiveValue(key);

            function handleValueChange() {
                state[key] = getNumber(input.value);

                var isPhField = key === 'current_ph' || key === 'desired_ph';
                var isInvalid = false;

                if (state[key] === null) {
                    isInvalid = !isPhField;
                } else if (!isPhField && state[key] <= 0) {
                    isInvalid = true;
                } else if (isPhField && (state[key] < 0 || state[key] > 14)) {
                    isInvalid = true;
                }

                if (isInvalid) {
                    input.classList.add('is-invalid');
                } else {
                    input.classList.remove('is-invalid');
                }

                updateLiveValue(key);
                syncVolumePreview();
                renderResult();
                persistState();
            }

            input.addEventListener('input', handleValueChange);
            input.addEventListener('change', handleValueChange);
        });

        restoreState();

        inputEls.forEach(function (input) {
            var key = input.getAttribute('data-prc-input');
            if (state[key] !== null && typeof state[key] !== 'undefined') {
                input.value = state[key];
            }
            updateLiveValue(key);
        });

        updateReferenceMarker();
        updateShapeFields();
        syncVolumePreview();
        renderResult();
    });
})();